import { StageOf } from '../workflow/phases.js';
import { OEP_ROLE_LABELS, type OEPRoleKey } from '../contracts/roles.js';
import type { OEPTask, OEPUserSnapshot } from './types.js';

export interface OEPHomeHeader { DeadlineLabel: 'Program wide' | 'Your next deadline' | 'Nothing due'; NextDeadline: string }

/** logic.js:522-523. */
export function BuildHomeHeader(s: OEPUserSnapshot, tasks: readonly OEPTask[]): OEPHomeHeader {
    if (tasks.length === 0) return { DeadlineLabel: 'Program wide', NextDeadline: s.Timeline.Stages[StageOf(s.Phase)].Deadline };
    const lead = tasks[0];
    return lead.DueOn
        ? { DeadlineLabel: 'Your next deadline', NextDeadline: lead.Due.split(' · ')[0] }
        : { DeadlineLabel: 'Nothing due', NextDeadline: lead.Due };
}

/** Roles held this season with nothing to do right now (logic.js:532, 538). Staff is never dormant. */
export function DormantRoles(s: OEPUserSnapshot, tasks: readonly OEPTask[]): { Role: OEPRoleKey; Label: string; Opens: string }[] {
    const active = new Set(tasks.map((t) => t.Role));
    return [...s.Roles]
        .filter((r) => r !== 'staff' && !active.has(r))
        .map((r) => ({ Role: r, Label: OEP_ROLE_LABELS[r].Label, Opens: OEP_ROLE_LABELS[r].Opens }));
}
